import React from 'react';

interface EmptyPlaceholderProps {
  text: string;
}

const EmptyPlaceholder: React.FC<EmptyPlaceholderProps> = ({ text }) => {
  return (
    <div className="my-settings__empty-container">
      <p className="my-settings__empty-message basic-16">{text}</p>
    </div>
  );
};

export default EmptyPlaceholder;
